var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',_vm._l(([..._vm.iconsArr]),function(icon,index){return _c('img',{key:index,attrs:{"width":_vm.size,"height":_vm.size,"src":require(`@creativecommons/cc-assets/icons/cc-${_vm.filename(icon)}`)}})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }